import type React from 'react';
import { Disclosure } from '@headlessui/react';
import OmniCleanAirLogo from './OmniCleanAirLogo';

const SimpleHeader: React.FC = () => {
  return (
    <div className="bg-gray-100 pb-24">
      <Disclosure as="nav" className="bg-gray-800">
        <div className="flex justify-between items-center px-4 py-3">
          <OmniCleanAirLogo />
        </div>
      </Disclosure>
    </div>
  );
};

export default SimpleHeader;
